import(/* webpackMode: "eager" */ "/home/jenkins/workspace/PwaSlotCash-test-pages/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/home/jenkins/workspace/PwaSlotCash-test-pages/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/home/jenkins/workspace/PwaSlotCash-test-pages/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/home/jenkins/workspace/PwaSlotCash-test-pages/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/jenkins/workspace/PwaSlotCash-test-pages/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"variable\":\"--font-roboto\",\"weight\":[\"400\",\"700\",\"900\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/jenkins/workspace/PwaSlotCash-test-pages/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/app/Main.tsx");
;
import(/* webpackMode: "eager" */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/app/styles/reset.css");
;
import(/* webpackMode: "eager" */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/app/styles/fontIcon.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/Master/SDialogFC/DialogPortal.tsx");
